module.exports = __webpack_public_path__ + "static/media/teacher.a6a8aeb0.png";